import request from '@/utils/request'

// 查询库存余额拆分表
export function apiGetInvInventoryBalanceSplitList (query) {
	return request({
		url: `/inv/invWmsStockSnapshotFpParts/list`,
		method: 'get',
		params: query
	})
}

// 导出库存余额拆分表
export function apiInvInventoryBalanceSplitExport (data) {
	return request({
		url: `/inv/invWmsStockSnapshotFpParts/export`,
		method: 'post',
		data
	})
}
// 成品库存转换为零部件库存
export function apiInvInventoryBalanceSplitGenerate () {
	return request({
		url: `/inv/invWmsStockSnapshotFpParts/snapshotFpCovertPartsStock`,
		method: 'post'
	})
}

// 查询快照列表下拉列表快照批次时间列表
export function apiGetSnapshotBatchs (query) {
  return request({
    url: '/inv/invWmsStockSnapshotFpParts/getSnapshotBatchList',
    method: 'get',
	params: query
  })
}
